import React from 'react';
import Clarity from '@microsoft/clarity';
import './KeepsakeCollections.css';

interface PackageFeature {
  icon: string;
  text: string;
}

interface Package {
  id: string;
  title: string;
  features: PackageFeature[];
  price: string;
  isPopular?: boolean;
}

interface KeepsakeCollectionsProps {
  onPackageSelect: (packageId: string) => void;
}

const packages: Package[] = [
  {
    id: 'moments',
    title: 'The Milestone Moment',
    features: [
      { icon: '📅', text: '3 days rental' },
      { icon: '📸', text: '20 edited photos' },
      { icon: '🎯', text: 'All digital candids' }
    ],
    price: '$249'
  },
  {
    id: 'memories',
    title: 'The First Chapter',
    features: [
      { icon: '📅', text: '7 days rental' },
      { icon: '📸', text: '50 edited photos' },
      { icon: '🎯', text: 'All digital candids' }
    ],
    price: '$349',
    isPopular: true
  },
  {
    id: 'legacy',
    title: 'The Whole Story',
    features: [
      { icon: '📅', text: '1 month rental' },
      { icon: '📸', text: '100 edited photos' },
      { icon: '🎯', text: 'All digital candids' }
    ],
    price: '$999'
  }
];

const KeepsakeCollections: React.FC<KeepsakeCollectionsProps> = ({ onPackageSelect }) => {
  return (
    <section className="keepsake-collections">
      <div className="keepsake-container">
        <h2 className="keepsake-heading text-script">Keepsake Collections</h2>
        
        <div className="packages-scroll-container">
          {packages.map((pkg) => (
            <div 
              key={pkg.id}
              className={`package-card ${pkg.isPopular ? 'is-popular' : ''}`}
            >
              {pkg.isPopular && <div className="popular-badge">Most Popular</div>}
              
              <div className="card-content">
                <h3 className="package-title text-script">{pkg.title}</h3>
                
                <ul className="features-list">
                  {pkg.features.map((feature, index) => (
                    <li key={index} className="feature-item">
                      <span className="feature-icon">{feature.icon}</span>
                      <span className="feature-text">{feature.text}</span>
                    </li>
                  ))}
                </ul>
                
                <div className="package-price">{pkg.price}</div>
                
                <button 
                  className="cta-button"
                  onClick={() => {
                    Clarity.event('package_select');
                    onPackageSelect(pkg.id);
                  }}
                >
                  Choose this Chapter
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default KeepsakeCollections;